export const shuffleType = function(arr) {
    let radiosList = []
    let checkList = []
    let judgeList = []
    for (let i = 0; i < arr.length; i++) {
        switch (arr[i].type) {
            case 1:
                radiosList.push(arr[i])
                break;
            case 2:
                checkList.push(arr[i])
                break;
            case 3:
                judgeList.push(arr[i])
                break;
            default:
                break;
        }
      }
    // for (let i = 0; i < judgeList.length; i++) {
    //   let randomIndex = Math.round(Math.random() * (judgeList.length - 1 - i)) + i;
    //   [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
    // }
      // for (let i = 0; i < radiosList.length; i++) {
      //   let randomIndex = Math.round(Math.random() * (radiosList.length - 1 - i)) + i;
      //   [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
      // }
      // for (let i = 0; i < checkList.length; i++) {
      //   let randomIndex = Math.round(Math.random() * (checkList.length - 1 - i)) + i;
      //   [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
      // }
    let judge = [];
    while(judgeList.length>0){
        let len=parseInt(Math.random()*judgeList.length);
        judge.push(judgeList[len]);
        judgeList.splice(len,1)  
      }
      let radios = [];
      while(radiosList.length>0){
        let len=parseInt(Math.random()*radiosList.length);
        radios.push(radiosList[len]);
        radiosList.splice(len,1)  
      }
      let check = [];
      while(checkList.length>0){
          let len=parseInt(Math.random()*checkList.length);
          check.push(checkList[len]);
          checkList.splice(len,1)  
        }
   
    
    let baseArr = judge.concat(radios).concat(check)
    return baseArr;
  }

  